(function() {
    'use strict';

    angular.module('remitEventsApp').controller('SiteController', function($state, $location) {
        var vm = this;

        vm.getTitle = function() {
            if (_.isObject($state.$current.data.pageHeader) && $state.$current.data.pageHeader.type === 'check') {
                var data = $state.$current.data.pageHeader;

                return $location.url().indexOf('/' + data.contractor) !== -1 ? data.then : data.else;
            }

            return $state.current.data.pageHeader || 'remitEventsApp.event.home.pageTitle';
        };
    });
})();
